export function getView(selected) {
  return Object.values(selected).some(v => v != null)
}
